import { BrandMark } from '../brand.js';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ApiError, api, setAuth } from '../lib/api.js';

export function SignIn() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  // Only allow same-origin relative paths as a return target.
  const rawNext = params.get('next') ?? '/';
  const next = rawNext.startsWith('/') && !rawNext.startsWith('//') ? rawNext : '/';

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || !password) return;
    setBusy(true);
    setError('');
    try {
      const r = await api.login(email.trim(), password);
      setAuth(r.token, r.email);
      nav(next, { replace: true });
    } catch (err) {
      setError(
        err instanceof ApiError && err.status === 429
          ? 'Too many failed attempts. Try again in 15 minutes.'
          : 'Invalid email or password.',
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="signin-wrap">
      <div className="signin-card">
        <div className="signin-logo">
          <BrandMark size={40} />
          <div className="signin-logo-text">
            <span className="signin-brand">TrapMap</span>
          </div>
        </div>

        <h1 className="signin-heading">Sign in</h1>
        <p className="signin-desc">Sign in to see who really holds a token.</p>

        <form className="signin-form" onSubmit={submit}>
          <label className="signin-field">
            <span>Email</span>
            <input
              type="email"
              className="signin-input"
              placeholder="you@pleco.xyz"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
              autoComplete="email"
              spellCheck={false}
            />
          </label>

          <label className="signin-field">
            <span>Password</span>
            <input
              type="password"
              className="signin-input"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </label>

          {error && <p className="signin-error">{error}</p>}

          <button type="submit" className="btn primary signin-btn" disabled={busy || !email.trim() || !password}>
            {busy ? 'Signing in…' : 'Sign in →'}
          </button>
        </form>
      </div>
    </div>
  );
}
